import { render, staticRenderFns } from "./WhoCanParticipate.vue?vue&type=template&id=99fde988&scoped=true&"
import script from "./WhoCanParticipate.vue?vue&type=script&lang=js&"
export * from "./WhoCanParticipate.vue?vue&type=script&lang=js&"
import style0 from "./WhoCanParticipate.vue?vue&type=style&index=0&id=99fde988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fde988",
  null
  
)

export default component.exports